"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'leftConfigPage',
  props: ['pointer'],
  data: function data() {
    return {
      activeNames: [1, 2, 3] /* 侧边栏组件显示 */,
      datas: [{
        "title": "基础组件",
        "components": [{
          "title": "标题文本",
          "name": "titleContent",
          "type": "1-1",
          "zdyicon": "icon-text"
        }, {
          "title": "图片",
          "name": "imgBottom",
          "type": "1-2",
          "zdyicon": "icon-img"
        },
        // {
        //   "title": "图片导航",
        //   "name": "graphicnavigation",
        //   "type": "1-3",
        //   "zdyicon": "icon-tupiandaohang"
        // },
        {
          "title": "搜索",
          "name": "search",
          "type": "1-4",
          "zdyicon": "icon-search"
        }, {
          "title": "辅助分割",
          "name": "borderLine",
          "type": "1-5",
          "zdyicon": "icon-border-line"
        }, {
          "title": "公告",
          "name": "notice",
          "type": "1-6",
          "zdyicon": "icon-notice"
        }, {
          "title": "电梯导航",
          "name": "elevatorNavigation",
          "type": "1-7",
          "zdyicon": "icon-diantidaohang"
        }, {
          "title": "热区切图",
          "name": "hotspotCutout",
          "type": "1-8",
          "zdyicon": "icon-hotspot-cutout"
        }, {
          "title": "视频",
          "name": "videoComponent",
          "type": "1-9",
          "zdyicon": "icon-video"
        }, {
          "title": "悬浮按钮",
          "name": "floatingButton",
          "type": "1-10",
          "zdyicon": "icon-floating-button"
        }]
      }]
    };
  },
  methods: {
    /**
     * 当拖动操作开始时，会触发此事件
     */
    drag: function drag(event) {
      this.pointer.show = true;
      var target = event.target.closest('.componList');
      event.dataTransfer.setData("componentName", target && target.dataset.name);
    },
    /**
     * 当拖动操作结束时（释放鼠标按钮或按下退出键），会触发此事件
     */
    dragends: function dragends(e) {
      this.pointer.show = false;
    }
  }
};